import { createSlice } from "@reduxjs/toolkit";
import { filterOrderByMilestone, sortAllView } from "../utils";

export const boardViewForAllocation = {
  boardView: {
    status: {
      nameOfViews: [],
      allItemsName: [],
      allViews: {},
    },
    milestone: {
      nameOfViews: [],
      allItemsName: [],
      allViews: {},
    },
  },
};

const defaultViewForSalesOrder = [
  "SALES NO",
  "PRODUCT",
  "CUSTOMER",
  "FACILITY",
  "REQUESTED SHIP DATE",
  "BATCH",
  "SERIAL",
  "LOCATION",
  "REQUIRED",
  "ALLOCATABLE",
  "ALLOCATED",
  "PICKED",
  "STATUS",
];

const defaultViewForMO = [
  "MANF NO",
  "PRODUCT",
  "FACILITY",
  "QUANTITY",
  "REQUIRED",
  "ALLOCATABLE",
  "ALLOCATED",
  "UOM",
  "WASTAGE %",
];

const initialState = {
  boardView: "false",
  allViews: {
    listView: {
      nameOfViews: [],
      allItemsName: [
        "ERP SUPPLIER",
        "FROM FACILITY",
        "TO FACILITY",
        "CONSOLIDATION STATUS",
        "CREATE DATE",
        "STATUS",
      ],
      allViews: {
        "Default View": [
          "ERP SUPPLIER",
          "FROM FACILITY",
          "TO FACILITY",
          "CREATE DATE",
          "CONSOLIDATION STATUS",
          "STATUS",
        ],
      },
    },
    boardView: {
      status: {
        nameOfViews: [],
        allItemsName: [
          "Draft",
          "Created",
          "Not Allocated",
          "Partially Allocated",
          "Fully Allocated",
          "Partially Cargo Ready",
          "Fully Cargo Ready",
          "Partially Dispatched",
          "Fully Dispatched",
          "Partially Received",
          "Fully Received",
          "Partially Receipted",
          "Fully Receipted",
          "Completed",
          "Cancelled",
        ],
        allViews: {
          "Default View": [
            "Fully Dispatched",
            "Partially Receipted",
            "Completed",
            "Partially Allocated",
            "Not Allocated",
          ],
        },
      },
      milestone: {
        nameOfViews: [],
        allItemsName: [],
        allViews: {},
      },
    },
  },

  allocation: {
    purchase: {
      listView: {
        nameOfViews: [],
        allItemsName: [
          "ORD NO",
          "ORDER NAME",
          "PRODUCT",
          "SUPPLIER",
          "TO FACILITY",
          "REQ DATE",
          "REQUIRED",
          "ALLOCATED",
          "DISPATCHED",
          "ALCTD VALUE",
          "ALCTD CBM",
          "STATUS",
        ],
        allViews: {
          "Default View": [
            "ORD NO",
            "ORDER NAME",
            "PRODUCT",
            "SUPPLIER",
            "TO FACILITY",
            "REQ DATE",
            "REQUIRED",
            "ALLOCATED",
            "DISPATCHED",
            "ALCTD VALUE",
            "ALCTD CBM",
            "STATUS",
          ],
        },
      },
      ...boardViewForAllocation,
    },
    transfer: {
      listView: {
        nameOfViews: [],
        allItemsName: [
          "ORD NO",
          "PRODUCT",
          "FROM FACILITY",
          "TO FACILITY",
          "REQ DATE",
          "REQUIRED",
          "ALLOCATABLE",
          "ALLOCATED",
          "DISPATCHED",
          "ALCTD VALUE",
          "ALCTD CBM",
          "STATUS",
        ],
        allViews: {
          "Default View": [
            "ORD NO",
            "PRODUCT",
            "FROM FACILITY",
            "TO FACILITY",
            "REQ DATE",
            "REQUIRED",
            "ALLOCATABLE",
            "ALLOCATED",
            "DISPATCHED",
            "ALCTD VALUE",
            "ALCTD CBM",
            "STATUS",
          ],
        },
      },
      ...boardViewForAllocation,
    },
    salesOrder: {
      listView: {
        nameOfViews: [],
        allItemsName: defaultViewForSalesOrder,
        allViews: {
          "Default View": defaultViewForSalesOrder,
        },
      },
    },
    manufacturingOrder: {
      listView: {
        nameOfViews: [],
        allItemsName: defaultViewForMO,
        allViews: {
          "Default View": defaultViewForMO,
        },
      },
    },
  },
  orderlineMapById: {
    purchase: null,
    transfer: null,
  },

  allTransferOrders: [],
  singleView: {},
  milestoneOrders: {},
  milestoneList: [],
  filterShipmentByMilestone: {},
  consignmentMappedById: {},

  allFilterField: [],
  allFilterCondition: [],
  filteredConsignmentByRule: null,
  filteredTransferAllocationForRule: { count: 0, results: [] },
  filteredPurchaseAllocationForRule: { count: 0, results: [] },
};

const newTransferOrderSlice = createSlice({
  name: "newTransferOrder",
  initialState,
  reducers: {
    setMilestoneOrdersForTransfer: (state, action) => {
      state.milestoneList = action.payload;
    },
    setAllViewsForTransfer: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.allViews = {
        listView: {
          ...state.allViews.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.allViews.listView.allViews, ...views.list.allViews },
        },
        boardView: {
          status: {
            ...state.allViews.boardView.status,
            nameOfViews: views.status.nameOfList,
            allViews: { ...state.allViews.boardView.status.allViews, ...views.status.allViews },
          },
          milestone: {
            nameOfViews: views.milestone.nameOfList,
            allViews: views.milestone.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setViewsForPurchaseAllocation: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);

      state.allocation.purchase.listView = {
        ...state.allocation.purchase.listView,
        nameOfViews: views.list.nameOfList,
        allViews: { ...state.allocation.purchase.listView.allViews, ...views.list.allViews },
      };
      state.allocation.purchase.completeListOfViews = data;
    },
    setViewsForTransferAllocation: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);

      state.allocation.transfer.listView = {
        ...state.allocation.transfer.listView,
        nameOfViews: views.list.nameOfList,
        allViews: { ...state.allocation.transfer.listView.allViews, ...views.list.allViews },
      };
      state.allocation.transfer.completeListOfViews = data;
    },

    setAllTransferOrders: (state, action) => {
      state.allTransferOrders = [...state.allTransferOrders, ...action.payload];
    },
    setOrderlineMapById: (state, action) => {
      let purchase = {};
      action.payload.forEach(item => {
        purchase[item.id] = item;
      });
      if (action.payload[0]["transfer_order"]) {
        state.orderlineMapById.transfer = purchase;
      } else {
        state.orderlineMapById.purchase = purchase;
      }
    },
    handleFilterTransferByMilestone: (state, action) => {
      const { filterd, mapConsignments } = filterOrderByMilestone(
        action.payload,
        state.milestoneList,
      );
      state.consignmentMappedById = mapConsignments;
      state.filterShipmentByMilestone = filterd;
    },
    updateFilterTransferByMilestone: (state, action) => {
      const filterd = { ...state.filterShipmentByMilestone };

      filterd[action.payload.sourceIndex] = filterd[action.payload.sourceIndex].filter(
        item => item !== action.payload.data.ids[0],
      );
      filterd[action.payload.id] = [...action.payload.data.ids, ...filterd[action.payload.id]];

      state.filterShipmentByMilestone = filterd;
    },
    setTransferAllocationForRule: (state, action) => {
      const { results, count } = action.payload;
      state.filteredTransferAllocationForRule = { results, count };
    },
    setPurchaseAllocationForRule: (state, action) => {
      const { results, count } = action.payload;
      state.filteredPurchaseAllocationForRule = { results, count };
    },
    updatePurchaseAllocatedQtyFromTransferV2: (state, action) => {
      const results = [...state.filteredPurchaseAllocationForRule.results];
      if (results.length > 0) {
        const { id, ...rest } = action.payload;
        const index = results.findIndex(item => item.id === id);
        if (index !== -1) {
          results[index] = {
            ...results[index],
            ...rest,
          };
        }
        state.filteredPurchaseAllocationForRule.results = results;
      }
    },
    updateTransferAllocatedQtyFromTransferV2: (state, action) => {
      const results = [...state.filteredTransferAllocationForRule.results];
      if (results.length > 0) {
        const { allocatable, allocated_qty, id, product_plan, status } = action.payload;
        const allocationIndex = results.findIndex(item => item.id === id);
        if (allocationIndex !== -1) {
          const allocation = results[allocationIndex];
          results[allocationIndex] = {
            ...allocation,
            allocatable,
            allocated_qty,
            status,
          };
          results.forEach((item, index) => {
            if (item.id !== id && item.product_plan === product_plan) {
              results[index] = { ...item, allocatable };
            }
          });
          state.filteredTransferAllocationForRule.results = results;
        }
      }
    },
    setViewsForSalesOrderAllocation: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);

      state.allocation.salesOrder.listView = {
        ...state.allocation.salesOrder.listView,
        nameOfViews: views.list.nameOfList,
        allViews: { ...state.allocation.salesOrder.listView.allViews, ...views.list.allViews },
      };
      state.allocation.salesOrder.completeListOfViews = data;
    },
    setViewsForManufacturingOrderAllocation: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);

      state.allocation.manufacturingOrder.listView = {
        ...state.allocation.manufacturingOrder.listView,
        nameOfViews: views.list.nameOfList,
        allViews: {
          ...state.allocation.manufacturingOrder.listView.allViews,
          ...views.list.allViews,
        },
      };
      state.allocation.manufacturingOrder.completeListOfViews = data;
    },
  },
});

export const {
  setMilestoneOrdersForTransfer,
  setAllViewsForTransfer,
  handleFilterTransferByMilestone,
  updateFilterTransferByMilestone,
  setAllTransferOrders,
  setOrderlineMapById,
  setViewsForPurchaseAllocation,
  setViewsForTransferAllocation,
  setViewsForSalesOrderAllocation,
  setViewsForManufacturingOrderAllocation,
  setTransferAllocationForRule,
  setPurchaseAllocationForRule,
  updatePurchaseAllocatedQtyFromTransferV2,
  updateTransferAllocatedQtyFromTransferV2,
} = newTransferOrderSlice.actions;

export default newTransferOrderSlice.reducer;
